(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["right-column"] && !Shopify.designMode) return;
  try {
    /* Hide empty shopify-block wrappers to eliminate flex gaps */
  requestAnimationFrame(function() {
    document.querySelectorAll('.right-column .shopify-block').forEach(function(el) {
      if (el.offsetHeight === 0) el.style.display = 'none';
    });
  });
  } catch(e) { console.error(e); }
})();

})();
